<template>
  <el-dialog
    :title="$t('financial.上传/查看附件')"
    :visible.sync="dialog.visible"
    :close-on-click-modal="false"
    :before-close="initDialog"
    top="10vh"
  >
    <div class="scroll-box">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <p class="mg-b-0">
            {{
              $t(
                "financial.请选选择你需要上传的文件。（单个文件大小不超过15MB)"
              )
            }}
          </p>
          <p class="mg-b-0 tx-danger">
            {{ $t("financial.注：您上传的文件会双向同步至对方的账号中") }}
          </p>
        </div>
        <div>
          <el-upload
            class="position-button"
            action=""
            :show-file-list="false"
            :auto-upload="false"
            :on-change="
              (file, fileList) => {
                getFile(file, fileList);
              }
            "
          >
            <el-button type="primary" class="upload-button" size="medium">{{
              $t("financial.点击上传")
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <hr />
      <div class="file-box">
        <div class="pd-5 border-line">
          <p class="tx-18">{{ userInfo.name }}</p>
          <template v-if="data.length">
            <div
              class="
                itemBox
                d-flex
                align-items-center
                justify-content-between
                mg-b-5
              "
              v-for="(item, index) of data"
              :key="index"
            >
              <div class="d-flex align-items-center">
                <div class="mg-r-10">
                  <svg t="1652181667914" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2680" width="20" height="20"><path d="M736.005 696.494H174.18c-17.673 0-32-14.327-32-32V255.582c0-17.673 14.327-32 32-32h157.213c7.96 0 15.635 2.967 21.525 8.321l47.547 43.222h335.54c17.673 0 32 14.327 32 32v357.369c0 17.673-14.327 32-32 32z m-529.825-64h497.825V339.125H388.094a32.002 32.002 0 0 1-21.525-8.321l-47.547-43.222H206.18v344.912z" fill="#11204d" p-id="2681"></path><path d="M853.18 821.092H317.509c-17.673 0-32-14.327-32-32s14.327-32 32-32H821.18V414.206c0-17.673 14.327-32 32-32s32 14.327 32 32v374.886c0 17.673-14.327 32-32 32z" fill="#11204d" p-id="2682"></path></svg>
                </div>
                <div>
                  <div class="single">{{ item.fileName }}</div>
                  <div>
                    {{ $t("financial.上传时间") }}：{{ item.timeCreated }}
                  </div>
                </div>
              </div>
              <div>
                <el-link @click="download(item)">下载</el-link>
                <br />
                <el-link v-if="item.type == 2" @click="del(item, index)"
                  >删除</el-link
                >
              </div>
            </div>
          </template>
          <div v-else>
            <span class="tx-12 tx-primary">暂无数据</span>
          </div>
        </div>
        <div class="pd-5">
          <p class="tx-18">{{ dialogModal.row.distributorName }}</p>
          <template v-if="distributor.length">
            <div
              class="
                itemBox
                d-flex
                align-items-center
                justify-content-between
                mg-b-5
              "
              v-for="(item, index) of distributor"
              :key="index"
            >
              <div class="d-flex align-items-center">
                <div class="mg-r-10">
                  <svg t="1652181667914" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2680" width="20" height="20"><path d="M736.005 696.494H174.18c-17.673 0-32-14.327-32-32V255.582c0-17.673 14.327-32 32-32h157.213c7.96 0 15.635 2.967 21.525 8.321l47.547 43.222h335.54c17.673 0 32 14.327 32 32v357.369c0 17.673-14.327 32-32 32z m-529.825-64h497.825V339.125H388.094a32.002 32.002 0 0 1-21.525-8.321l-47.547-43.222H206.18v344.912z" fill="#11204d" p-id="2681"></path><path d="M853.18 821.092H317.509c-17.673 0-32-14.327-32-32s14.327-32 32-32H821.18V414.206c0-17.673 14.327-32 32-32s32 14.327 32 32v374.886c0 17.673-14.327 32-32 32z" fill="#11204d" p-id="2682"></path></svg>
                </div>
                <div>
                  <div class="single">{{ item.fileName }}</div>
                  <div>
                    {{ $t("financial.上传时间") }}：{{ item.timeCreated }}
                  </div>
                </div>
              </div>
              <div>
                <el-link @click="download(item)">下载</el-link>
                <br />
                <!-- <el-link v-if="item.type == 1" @click="del(item, index)">删除</el-link> -->
              </div>
            </div>
          </template>
          <div v-else>
            <span class="tx-12 tx-primary">暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save()">
        {{ $t("order.确定") }}
      </el-button>
      <el-button @click="initDialog()">
        {{ $t("financial.取消") }}
      </el-button>
    </div>
    <modal-loading :show="loading"></modal-loading>
  </el-dialog>
</template> 
<script>
export default {
  name: "AttachmentDialog",
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {
          visible: false,
          row: {},
        };
      },
    },
  },
  data() {
    return {
      dialogModal: this.dialog,
      userInfo: store.get("userInfo"),
      loading: false,
      distributor: [],
      data: [],
    };
  },
  watch: {
    dialog: {
      handler: function () {
        if (this.dialogModal.row.attaches) {
            let arrary = []
          arrary =  this.dialogModal.row.attaches.filter((item) => {
            return item.status == 1;
          });
          arrary.forEach((element) => {
            if (element.type == 2) {
              this.data.push(element);
            }
            if (element.type == 1) {
              this.distributor.push(element);
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initDialog() {
      this.dialog.visible = false;
      this.dialog.row = {};
    },
    save() {
      this.initDialog();
      this.$parent.toPage(1);
    },
    getFile(file) {
      let params = {
        id: this.dialogModal.row.id,
        "@file": file.raw,
      };
      this.loading = true;
      $.api_call("api.Bill.uploadAttachFile", params, (r) => {
        if (r.ErrorCode == "9999") {
          this.loading = false;
          this.data.push(r.Data.Results);
          ShowTip(this.$t("financial.文件上传成功"), "success");
        } else {
          this.loading = false;
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    del(item, index) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: this.dialogModal.row.id,
            attachId: item.id,
          };
          this.loading = true;
          $.api_call("api.Bill.deleteAttachFile", params, (r) => {
            if (r.ErrorCode == "9999") {
              this.loading = false;
              ShowTip(this.$t("product.删除成功"), "success");
              this.data.splice(index, 1);
            } else {
              this.loading = false;
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          });
        })
        .catch(() => {});
    },
    download(item) {
      let newWindow = window.open();
      newWindow.location = item.url;
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  border: 1px solid #eee;
}
.scroll-box {
  height: 60vh;
  // overflow-y: auto;
}
.file-box {
  height: calc(60vh - 70px);
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow-y: auto;
}
.itemBox {
  padding: 10px;
  background: #eee;
}
.border-line {
  border-right: 1px dashed #eee;
}
.single {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
</style>

